import classNames from 'classnames/bind';
import { IItinerary } from 'common/types';
import {
  ISearchParamItinerary,
  SearchType,
  SeatClass,
  getLinkPair,
} from 'contexts/searchParams';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  adult: number;
  child: number;
  infant: number;
  fareType?: string;
  isDirect?: boolean;
  itinerary: IItinerary[];
}

export default function NoDirect({
  adult,
  child,
  infant,
  fareType,
  isDirect,
  itinerary,
}: IProps) {
  const router = useRouter();
  const search = (e: React.MouseEvent) => {
    const [href, as] = getLinkPair(
      itinerary.map(
        (el): ISearchParamItinerary => ({
          ...el,
          departureCity: {
            code: el.departureAirport,
            name: '',
            isDomestic: false,
          },
          arrivalCity: {
            code: el.arrivalAirport,
            name: '',
            isDomestic: false,
          },
        }),
      ),
      { adult, child, infant },
      fareType as SeatClass,
      !isDirect,
      SearchType.INTERNATIONAL,
    );
    router.push(href, as, { shallow: false });
  };
  return (
    <div className={cx('NoDirect')}>
      <p className={cx('txt')}>경유편을 포함한 모든 항공권으로 다시 조회</p>
      <button
        className={cx('search')}
        type="button"
        data-event-nlog="click"
        data-event-area-code="isr.searchall"
        onClick={search}
      >
        항공권 검색
      </button>
    </div>
  );
}
